import React, { useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import { godModeInfo, endGodMode } from '../../godMode/session';

/**
 * Bandeau permanent du mode intervention (SPEC §4.3) : il dit, sur CHAQUE écran
 * du compte client, que ce n'est pas le client qui regarde. Non masquable, collé
 * en haut (`sticky`), au-dessus de la barre latérale (qui se décale de sa
 * hauteur, 2,5 rem, cf. Sidebar3).
 */
const HEURE = { hour: '2-digit', minute: '2-digit' };

function nomAffiche(admin) {
  if (!admin) return 'Équipe BackStageRate';
  const nom = [admin.firstName, admin.lastName].filter(Boolean).join(' ').trim();
  return nom || admin.email || 'Équipe BackStageRate';
}

function heureDeFin(expiresAt) {
  if (!expiresAt) return null;
  const date = new Date(expiresAt);
  return Number.isNaN(date.getTime()) ? null : date.toLocaleTimeString('fr-FR', HEURE);
}

export default function GodModeBanner() {
  const [retour, setRetour] = useState(false);
  const info = godModeInfo();
  if (!info) return null;

  const fin = heureDeFin(info.expiresAt);
  const texte = `Mode intervention — ${nomAffiche(info.platformAdmin)} (BackStageRate) dans ${info.companyName || 'ce compte'}${fin ? ` · fin à ${fin}` : ''}`;

  async function revenir() {
    if (retour) return;
    setRetour(true);
    // endGodMode quitte la page ; il ne lève jamais.
    await endGodMode();
  }

  return (
    <div
      role="status"
      className="sticky top-0 z-[60] flex min-h-10 items-center justify-between gap-3 bg-amber-400 px-4 py-1.5 text-sm font-medium text-slate-900 shadow"
    >
      <span className="flex min-w-0 items-center gap-2">
        <ShieldAlert size={16} className="shrink-0" aria-hidden="true" />
        <span className="min-w-0 lg:truncate" title={texte}>{texte}</span>
      </span>
      <button
        type="button"
        onClick={revenir}
        disabled={retour}
        className="btn btn-xs shrink-0 border-slate-900 bg-slate-900 text-white hover:bg-slate-700 disabled:opacity-70"
      >
        {retour ? 'Retour en cours…' : 'Revenir au back-office'}
      </button>
    </div>
  );
}
